const recipes = [
  {
    id: 775,
    default_rating: 5,
    cooking_time: 45,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-05/84583509-4b9b8ab4927f47b68421bb8150b8cfad.webp",
    slug: "chicken-sandwich",
    title: "Chicken Sandwich",
    ingredient_count: 8,
  },
  {
    id: 682,
    default_rating: 5,
    cooking_time: 15,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-02/Masala_Milk-2ab9b8a26ddc45998f4c6d8cde6ff9ec.jpg",
    slug: "masala-milk",
    title: "Masala Milk",
    ingredient_count: 8,
  },
  {
    id: 434,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-06/Mix_Veggies_in_Spinach_Gravy-496a1d69c8b94c2891273d2a0ef7c0f5.png",
    slug: "mix-veggies-in-spinach-gravy",
    title: "Mix Veggies in Spinach Gravy",
    ingredient_count: 14,
  },
  {
    id: 580,
    default_rating: 5,
    cooking_time: 15,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-12/Aloo_Paratha-7cd4276b9c6b412ca0a7e067fe00015f.jpg",
    slug: "aloo-parantha",
    title: "Aloo Parantha",
    ingredient_count: 10,
  },
  {
    id: 719,
    default_rating: 5,
    cooking_time: 15,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-03/Jeera-Alu-5784ce80f0554e73ae7bb4795a2337f0.jpg",
    slug: "jeera-aloo",
    title: "Jeera Aloo",
    ingredient_count: 10,
  },
  {
    id: 516,
    default_rating: 5,
    cooking_time: 45,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-07/Spinach_Makhana-1ba414cb8ff64c1398a330281f749959.png",
    slug: "spinach-makhana",
    title: "Spinach Makhana",
    ingredient_count: 11,
  },
  {
    id: 358,
    default_rating: 5,
    cooking_time: 60,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-01/Stuffed_Capsicum-a2cf47b18f824524bc090adfb71a0875.jpg",
    slug: "stuffed-capsicum",
    title: "Stuffed Capsicum",
    ingredient_count: 8,
  },
  {
    id: 738,
    default_rating: 5,
    cooking_time: 15,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-03/Mango_Chaat-1e9654c590f34c9d85c4c5568b1acabc.jpg",
    slug: "mango-fruit-chaat",
    title: "Mango Fruit Chaat",
    ingredient_count: 6,
  },
  {
    id: 532,
    default_rating: 5,
    cooking_time: 10,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-01/Cucumber_Avocado_Salad-f5d14a1508ff4ba8b7deead9026bb946.jpg",
    slug: "cucumber-avocado-salad",
    title: "Cucumber Avocado Salad",
    ingredient_count: 8,
  },
  {
    id: 666,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-02/Kesariya_Metha_Chwal-310ae82f74054445b989ed246c243ea4.jpg",
    slug: "kesariya-meethe-chawal",
    title: "Kesariya Meethe Chawal",
    ingredient_count: 9,
  },
  {
    id: 548,
    default_rating: 5,
    cooking_time: 10,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-07/Green_Chutney-f8b4c3a8357646fab47ded160f4453d5.png",
    slug: "green-chutney",
    title: "Green Chutney",
    ingredient_count: 8,
  },
  {
    id: 769,
    default_rating: 5,
    cooking_time: 45,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-05/shutterstock_1264839352-14d0359a8331411794ad8e10210cc9ab.jpg",
    slug: "grilled-chicken-salad",
    title: "Grilled Chicken Salad",
    ingredient_count: 15,
  },
  {
    id: 677,
    default_rating: 5,
    cooking_time: 60,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-02/Dahi_Bhala-2dc1d427036c4a6f8534a95d7828a161.jpg",
    slug: "dahi-bhalla",
    title: "Dahi Bhalla",
    ingredient_count: 3,
  },
  {
    id: 414,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-01/Savory_spinach_Pancake-ca10f43912c648a2b7107a77f1d09cc9.jpg",
    slug: "savory-spinach-pancakes",
    title: "Savory Spinach Pancakes",
    ingredient_count: 15,
  },
  {
    id: 696,
    default_rating: 5,
    cooking_time: 15,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-03/Watermelon-juice-e48b9386fafd4f929430362eb0e51118.jpg",
    slug: "watermelon-juice",
    title: "Watermelon Juice",
    ingredient_count: 4,
  },
  {
    id: 575,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-12/Baked_Vegetable_Tikki-2aa650030c484dfd924dfa6ec9471b8f.jpg",
    slug: "baked-vegetable-tikkis",
    title: "Baked Vegetable Tikkis",
    ingredient_count: 10,
  },
  {
    id: 714,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-03/Sabusaana_Thalipeeth-d9618968b3d74f1398d8cc881feeab61.jpg",
    slug: "sabudana-thalipeeth",
    title: "Sabudana Thalipeeth",
    ingredient_count: 10,
  },
  {
    id: 511,
    default_rating: 5,
    cooking_time: 10,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-07/Pear_Oatmeal_Porridge-bbea8f9c10a0477bab7dd18ff110aa10.png",
    slug: "pear-oatmeal-porridge",
    title: "Pear Oatmeal Porridge",
    ingredient_count: 4,
  },
  {
    id: 732,
    default_rating: 5,
    cooking_time: 45,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-03/quaker_homestylechickenbarleysoup_750x433-4f538844f244423086d4967fa30abe5f.jpg",
    slug: "chicken-oats-soup",
    title: "Chicken Oats Soup",
    ingredient_count: 5,
  },
  {
    id: 609,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-12/Jowar_Paratha-c014476fe1a841188eacef25d0b10baa.jpg",
    slug: "jowar-veggie-parantha",
    title: "Jowar Veggie Parantha",
    ingredient_count: 9,
  },
  {
    id: 527,
    default_rating: 5,
    cooking_time: 90,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-01/Chicken_Barley_Soup-a962d2ef28de4443886facc424cbf86f.jpg",
    slug: "chicken-barley-soup",
    title: "Chicken Barley Soup",
    ingredient_count: 9,
  },
  {
    id: 373,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-06/Kadi_Patta_Chutney-326e5479b00f4943a856a69370d7e218.jpg",
    slug: "kadi-patta-chutney",
    title: "Kadi Patta Chutney",
    ingredient_count: 5,
  },
  {
    id: 661,
    default_rating: 5,
    cooking_time: 60,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2023-02/Kulfi-751edb2be5f84579adb9fa261f89be89.jpg",
    slug: "kulfi",
    title: "Kulfi",
    ingredient_count: 5,
  },
  {
    id: 543,
    default_rating: 5,
    cooking_time: 10,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-07/Berry_Smoothie-331f7339f13245f49d268c5a416630e4.png",
    slug: "berry-smoothie",
    title: "Berry Smoothie",
    ingredient_count: 5,
  },
  {
    id: 393,
    default_rating: 5,
    cooking_time: 30,
    cover_image:
      "https://d1mxd7n691o8sz.cloudfront.net/static/recipe/recipe/2022-06/Jowar_Oats_Cheela-24edbba7f21343b09af3ae292711d169.jpg",
    slug: "jowar-vegetable-cheela",
    title: "Jowar Vegetable Cheela",
    ingredient_count: 12,
  },
];

export default recipes;
